import InfiniteScroll from 'components/InfiniteScroll'
import { useBoardContext } from 'dataProviders/Board'
import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import fetchBlockers from '../sagas/fetchBlockers'
import createSortedBlockersSelector from '../selectors/createSortedBlockersSelector'

type Props = {
  children: (blockers: any[]) => React.ReactNode
}

const Blockers: React.FC<Props> = ({
  children,
}) => {
  const boardContext = useBoardContext()

  const areBlockersLoading = useSelector<any, boolean>(state => state['view-board'].blockers[boardContext.id].isLoading)
  const areBlockersLoaded = useSelector<any, boolean>(state => state['view-board'].blockers[boardContext.id].isLoaded)

  const getBlockerIds = useCallback(
    state => state['view-board'].blockers[boardContext.id].ids,
    [boardContext.id],
  )

  const blockers = useSelector<any, any[]>(useMemo(() => createSortedBlockersSelector(getBlockerIds), [getBlockerIds]))

  const dispatch = useDispatch()

  const loadBlockers = useCallback(() => {
    dispatch(fetchBlockers({
      boardId: boardContext.id
    }))
  }, [])

  return (
    <InfiniteScroll
      isLoading={areBlockersLoading}
      isLoaded={areBlockersLoaded}
      onLoadMore={loadBlockers}
    >
      {areBlockersLoaded && children(blockers)}
    </InfiniteScroll>
  )
}

export default Blockers
